import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    signal,
} from '@angular/core';
import { injectUser } from '@quipex/core/auth';
import {
    QUIPPY_CHAT_ENTRY,
    injectQuippySuggestions,
    prepareQuippySuggestionDraft,
    QuippyHomeSuggestedActions,
    type HomeSummaryLink,
    type QuippyScope,
    type QuippySuggestedQuestion,
} from '@quipex/feature/quippy-conversation';

import { APP_QUIPPY_HOME_ACTIONS } from './home-actions';

@Component({
    selector: 'qpx-app-quippy-suggestions',
    imports: [QuippyHomeSuggestedActions],
    template: `
        <qpx-quippy-home-suggested-actions
            headingId="app-home-suggestions-title"
            [questions]="questions()"
            [secondaryActions]="summaryLinks()"
            [userType]="user()?.userType"
            [resetKey]="resetKey()"
            scopeKind="portfolio"
            (questionSelected)="selectQuestion($event)"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'block h-full min-w-0' },
})
export class AppQuippySuggestions {
    private readonly chatEntry = inject(QUIPPY_CHAT_ENTRY);
    protected readonly user = injectUser();
    private readonly scope = computed<QuippyScope>(() => ({
        kind: 'portfolio',
    }));

    protected readonly resetKey = computed(
        () => `${this.user()?.id ?? ''}:${this.user()?.organisationId ?? ''}`
    );
    protected readonly questions = injectQuippySuggestions(this.scope);
    protected readonly summaryLinks =
        inject(APP_QUIPPY_HOME_ACTIONS, { optional: true }) ??
        signal<readonly HomeSummaryLink[]>([]);

    protected selectQuestion(question: QuippySuggestedQuestion): void {
        void this.chatEntry.navigate({
            target: this.scope(),
            prompt: {
                kind: question.action === 'prefill' ? 'draft' : 'submit',
                text:
                    question.action === 'prefill'
                        ? prepareQuippySuggestionDraft(question.text)
                        : question.text,
            },
        });
    }
}
